import React from "react";
import Navbar from "../../components/Navbar/MainNavbar/Navbar";
import Footer from "../../components/Footer/Footer";
import BlogDetail from "../../components/BlogDetail/BlogDetail";

const BlogDetailsPage = () => {
  return (
    <>
      <Navbar />
      <BlogDetail />
      <Footer />
    </>
  );
};

export default BlogDetailsPage;
